import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalization } from '@/features/localization/LocalizationProvider';
import { Globe } from 'lucide-react';

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const { locale, setLocale, availableLocales, isLoading } = useLocalization();

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLocale = e.target.value as 'en' | 'sw';
    setLocale(newLocale);
  };

  return (
    <div className="flex items-center gap-2">
      <Globe className="w-4 h-4 text-muted-foreground" />
      <select
        value={locale}
        onChange={handleLanguageChange}
        disabled={isLoading}
        className="px-3 py-1 text-sm border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-card dark:bg-gray-800 dark:border-gray-600 dark:text-white"
      >
        {availableLocales.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.nativeName}
          </option>
        ))}
      </select>
    </div>
  );
};

// Compact version for header/navbar
export const CompactLanguageSwitcher: React.FC = () => {
  const { locale, setLocale, availableLocales, isLoading } = useLocalization();

  return (
    <button
      onClick={() => {
        const currentIndex = availableLocales.findIndex(l => l.code === locale);
        const nextIndex = (currentIndex + 1) % availableLocales.length;
        setLocale(availableLocales[nextIndex].code);
      }}
      disabled={isLoading}
      className="flex items-center gap-1 px-2 py-1 text-sm font-medium text-foreground hover:text-foreground dark:text-gray-300 dark:hover:text-white transition-colors"
      title="Switch Language"
    >
      <Globe className="w-4 h-4" />
      <span className="uppercase">{locale}</span>
    </button>
  );
};